module.exports = __webpack_public_path__ + "img/6-icono-completados-selected.b4ca8665.svg";